import * as Comlink from 'comlink'
import type { WorkerAPI } from './index'
import WorkerFactory from './index?worker'

// Initialize the worker
let workerInstance: Worker | null = null
let workerAPI: Comlink.Remote<WorkerAPI> | null = null

/**
 * Register any custom transfer handlers for complex objects if needed
 * For example, if we need to transfer Blob objects
 */
function registerTransferHandlers() {
  // Example: Register Blob transfer handler if needed
  // Comlink.transferHandlers.set('Blob', {
  //   canHandle: obj => obj instanceof Blob,
  //   serialize: obj => [obj, [obj]],
  //   deserialize: obj => obj
  // })
}

/**
 * Gets or creates the worker instance and returns its API
 */
export function getWorkerAPI(): Comlink.Remote<WorkerAPI> {
  if (!workerAPI) {
    // Register transfer handlers
    registerTransferHandlers()

    // Create the worker only once
    if (!workerInstance) {
      // Create a new worker instance
      workerInstance = new WorkerFactory()
    }

    // Wrap the worker with Comlink to get a proxy to the exposed API
    if (workerInstance) {
      const channel = new MessageChannel()

      channel.port1.onmessage = (e) => {
        window.postMessage(e.data)
      }

      workerInstance.postMessage({ port: channel.port2 }, [channel.port2])

      workerAPI = Comlink.wrap<WorkerAPI>(workerInstance)
    }
  }

  // This should never happen in practice since we just created the worker,
  // but we need to handle it for TypeScript
  if (!workerAPI) {
    throw new Error('Failed to initialize worker')
  }

  return workerAPI
}

/**
 * Terminates the worker if it exists
 */
export function terminateWorker() {
  if (workerInstance) {
    workerInstance.terminate()
    workerInstance = null
    workerAPI = null
  }
}
